const FLOW_ID_STORAGE_KEY = 'asasFlowId';

export const ORIGIN_ID = 'jornal';

export function generateFlowId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `flow-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function persistFlowId(flowId: string): void {
  try {
    localStorage.setItem(FLOW_ID_STORAGE_KEY, flowId);
  } catch (e) {
    // ignore if localStorage not available in test env
  }
}

export function readFlowId(): string | null {
  try {
    return localStorage.getItem(FLOW_ID_STORAGE_KEY);
  } catch (e) {
    return null;
  }
}

export function clearFlowId(): void {
  try {
    localStorage.removeItem(FLOW_ID_STORAGE_KEY);
  } catch (e) {
    // ignore if localStorage not available in test env
  }
}
